import genererModeCalculHonoraire from '@/services/devis/genererModeCalculHonoaire';

export default function genererMandat() {
  return {
    tiersId: null,
    dateDebut: null,
    dateFin: null,
    role: null,
    referenceClientObligatoire: false,
    modeCalculHonoraire: genererModeCalculHonoraire(),
  };
}
